
import { NgModule } from "@angular/core";
import { PercentagePipe } from "./percentage.pipe";
import { DollarValuePipe } from "./dollar-value.pipe";
import { CustomDatePipe } from './custom-date.pipe';
import { IdValuePipe } from './id-value.pipe';
import { InfiniteScrollComponent } from "src/app/components/features/client/transactions/infinite-scroll/infinite-scroll.component";
import { NumberOrDashPipe } from "./number-or-dash.pipe";
import {BankersRoundPipe} from "./bankers-round-pipe";

@NgModule({
  declarations: [PercentagePipe, DollarValuePipe, CustomDatePipe, IdValuePipe, InfiniteScrollComponent, NumberOrDashPipe, BankersRoundPipe],
  exports: [PercentagePipe, DollarValuePipe, CustomDatePipe, IdValuePipe, InfiniteScrollComponent, NumberOrDashPipe, BankersRoundPipe]
})
export class UtilsModule {}
